(ns ycweb.app.website.dlp.widgets.articletext
  (:require
   [rum.core :as rum]
   [util.transform :as trf]))

(rum/defc article-text < rum/reactive [{is-article? :isarticle} {:keys [properties]}]
  (let [{:article-text/keys [content]} properties]
    (when content
      [:div.yc-section.yc-simple-text
       {:class [(when (trf/toboolean is-article?) "yc-article")]
        :dangerouslySetInnerHTML
        {:__html
         content}}])))
